import React, { useState, useEffect } from "react";
import Slider from "react-slick"
import { StaticImage } from "gatsby-plugin-image"
import { IsEmpty, extractIframeSrc } from "../../helpers/HelperFunctions.js"
import Button from "../../components/Button.js"
import VideoThumbnail from "./VideoThumbnail.js"
import VideoModal from "./VideoModal.js"

const VideoCarousel = props => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedVideoUrl, setSelectedVideoUrl] = useState("")

  const openModal = url => {
    setSelectedVideoUrl(url)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSelectedVideoUrl("")
  }

  useEffect(() => {
    handleSlideFocusFix();
  }, []);

  function handleSlideFocusFix() {
    const allSlides = document.querySelectorAll('.slick-slide');

    allSlides.forEach((slide) => {
      const focusableEls = slide.querySelectorAll(
        'a, button, input, textarea, select, [data-manage-tabindex]'
      );

      const isActive = slide.classList.contains('slick-active') && !slide.classList.contains('slick-cloned');

      focusableEls.forEach((el) => {
        if (isActive) {
          el.setAttribute('tabindex', '0');
          el.removeAttribute('aria-hidden');
        } else {
          el.setAttribute('tabindex', '-1');
          el.setAttribute('aria-hidden', 'true');
        }
      });
    });

    const dotButtons = document.querySelectorAll('.slick-dots button');
    dotButtons.forEach((button) => {
      button.setAttribute('tabindex', '-1');
    });
  }

  const videos = props.listOfVideos.value?.map(({ elements }, i) => ({
    index: i + 1,
    id: props.listOfVideos.value[i].id,
    iframe: elements.external_iframe_link.value,
    title: elements.video_title.value,
    description: elements.video_caption_text.value,
    transcript: elements.transcript.value,
    duration: elements.video_duration.value,
  }))

  const iframeSrcList = videos?.map((item, i) => {
    const html = item.iframe
    const src = extractIframeSrc(html)
    return {
      id: item.id,
      caption: item.description,
      iframeSrc: src,
    }
  })
  
  const settings = {
    dots: true,
    infinite: videos.length > 1 ? true : false,
    centerMode: true,
    centerPadding: "100px",
    slidesToShow: 1,
    speed: 500,
    arrows: true,
    afterChange: handleSlideFocusFix,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <>
      <div className="ou-video-playlist-carousel-header-wrapper"></div>

      <div className="ou-video-carousel-container">
        <Slider {...settings}>
          {videos?.map((video, index) => {
            var transcriptAriaLabel = "Read transcript"
            if (
              IsEmpty(video.transcript[0]) ||
              IsEmpty(video.transcript[0].description)
            ) {
              transcriptAriaLabel = "Read transcript"
            } else {
              transcriptAriaLabel = video.transcript[0].description
            }

            return (
              <>
                <div key={index} className="ou-video-slide">
                  <div className="ou-carousel-video">
                    {/* <div className="ou-programme-article-iframe-container" dangerouslySetInnerHTML={{ __html: video.iframe }} /> */}

                    <div
                      key={video.id}
                      className="cursor-pointer margin-top-ten"
                      tabIndex="0"
                      data-manage-tabindex
                      onClick={() => openModal(iframeSrcList[index].iframeSrc)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          openModal(iframeSrcList[index].iframeSrc);
                        }
                      }}
                    >
                      <VideoThumbnail
                        iframeSrc={iframeSrcList[index].iframeSrc}
                      />
                    </div>
                  </div>
                </div>

                <div className="ou-video-playlist-content">
                  <div className="ou-video-title-container">
                    {videos.length > 1 && (
                      <span className="ou-video-index">{video.index}. </span>
                    )}
                    <h4 className="ou-video-title">{video.title}</h4>
                  </div>
                  <p className="ou-video-description">{video.description}</p>

                  {!IsEmpty(video.transcript) && (
                    <Button
                      link={video.transcript[0].url}
                      text={[
                        <i
                          key={"tile-button-" + video.transcript.id}
                          className="fa fa-bars"
                          aria-hidden="true"
                        ></i>,
                        "Transcript",
                      ]}
                      class="ou-link--primary ou-link--transcript"
                      target="_blank"
                      linkType="External"
                      label={transcriptAriaLabel}
                    />
                  )}
                </div>
              </>
            )
          })}
        </Slider>
      </div>

      <VideoModal
        isOpen={isModalOpen}
        onClose={closeModal}
        videoUrl={selectedVideoUrl}
      />
    </>
  )
}

export default VideoCarousel
